var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowFall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0901 4.14673C15.2992 4.3475 15.306 4.67978 15.1052 4.8889L11.5779 8.56322C11.4789 8.66633 11.3421 8.72461 11.1992 8.72461C11.0563 8.72461 10.9195 8.66633 10.8206 8.56322L8.67969 6.33314L6.14268 8.97586L7.9502 10.7111L2.12891 12.3989L3.57784 6.51361L5.38536 8.24884L8.30103 5.21168C8.40001 5.10858 8.53676 5.05029 8.67969 5.05029C8.82262 5.05029 8.95936 5.10858 9.05835 5.21168L11.1992 7.44176L14.3479 4.16188C14.5487 3.95275 14.8809 3.94597 15.0901 4.14673Z",
    fill: "#F23939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFall);
export default __webpack_public_path__ + "static/media/ArrowFall.ecfdbfddc74a609391f21bb748923804.svg";
export { ForwardRef as ReactComponent };